import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  createGst,
  getHsn,
  updateGst,
} from "data/server_apis/commodityService";

const initialState = {
  status: {},
  HSNS: [],
};
export const createGstThunk = createAsyncThunk(
  "productGst/create",
  async (data, { rejectWithValue }) => {
    try {
      return (await createGst(data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);
export const updateGstThunk = createAsyncThunk(
  "productGst/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      return (await updateGst(id, data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const getHsnThunk = createAsyncThunk(
  "productGst/getHsn ",
  async (_, { rejectWithValue }) => {
    try {
      return (await getHsn()).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);
const productGstSlice = createSlice({
  name: "productGst",
  initialState,
  reducers: {
    clearAction(state, action) {
      state.status = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createGstThunk.pending, (state, action) => {
        state.status = { loading: "create" };
      })
      .addCase(createGstThunk.fulfilled, (state, action) => {
        state.status = { success: "create" };
      })
      .addCase(createGstThunk.rejected, (state, action) => {
        state.status = { error: "create", errorMsg: action.payload?.message };
      });

    builder
      .addCase(updateGstThunk.pending, (state, action) => {
        state.status = { loading: "update" };
      })
      .addCase(updateGstThunk.fulfilled, (state, action) => {
        state.status = { success: "update" };
      })
      .addCase(updateGstThunk.rejected, (state, action) => {
        state.status = { error: "update", errorMsg: action.payload?.message };
      });

    builder
      .addCase(getHsnThunk.pending, (state, action) => {
        state.status = { loading: "hsn" };
      })
      .addCase(getHsnThunk.fulfilled, (state, action) => {
        state.HSNS = action.payload;
        state.status = { success: "hsn" };
      })
      .addCase(getHsnThunk.rejected, (state, action) => {
        state.status = { error: "hsn", errorMsg: action.payload?.message };
      });
  },
});

export const { clearAction } = productGstSlice.actions;

export default productGstSlice.reducer;
